/* eslint-disable default-case, no-param-reassign, no-shadow, consistent-return */
/* eslint-disable array-callback-return, no-return-assign */
/*
 *
 * LossDraft reducer
 *
 */
import produce from 'immer';

import { RESET_USER_STATE } from '../Main/constants';
import {
  ATTACHMENT_DOCUMENT_CATEGORY,
  CHANGE_FORM_FIELD_VALUE,
  CHANGE_SELECTED_CLAIM_NUMBER,
  CHANGE_SELECTED_MESSAGE_ID,
  CHANGE_SELECTED_TAB,
  CHANGE_STEP,
  CHOOSE_DOCUMENT,
  CHOOSE_DOCUMENT_CANCELLATION,
  CHOOSE_DOCUMENT_FAILURE,
  CHOOSE_DOCUMENT_SUCCESS,
  DOWNLOAD_ATTACHMENT,
  DOWNLOAD_ATTACHMENT_FAILURE,
  FETCH_ATTACHMENT_CANCELLED,
  FETCH_ATTACHMENT_FAILURE,
  FETCH_ATTACHMENT_SUCCESS,
  FETCH_LOSSDRAFT,
  FETCH_LOSSDRAFT_FAILURE,
  FETCH_LOSSDRAFT_SUCCESS,
  FETCH_MESSAGES,
  FETCH_MESSAGES_FAILURE,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGE_DETAILS,
  FETCH_MESSAGE_DETAILS_FAILURE,
  FETCH_MESSAGE_DETAILS_SUCCESS,
  POST_MESSAGE,
  POST_MESSAGE_FAILURE,
  POST_MESSAGE_SUCCESS,
  POST_REPLY,
  POST_REPLY_FAILURE,
  POST_REPLY_SUCCESS,
  PROCESS_DOCUMENT,
  PROCESS_DOCUMENT_FAILURE,
  PROCESS_DOCUMENT_SUCCESS,
  REMOVE_ATTACHMENT,
  RESET_BANNER_ERROR,
  RESET_FORM_STATE,
  RESET_LOSS_DRAFT_STATE,
  RESET_REQUEST_STATUS,
  RESET_SERVICE_ERROR,
  RESET_STEP,
  SET_ATTACHMENT_FILE,
  SET_BANNER_ERROR,
  TOGGLE_ATTACHMENT_DRAWER,
  UPDATE_ATTACHMENTS,
  UPDATE_CLAIM_NUMBERS_READ,
  UPLOAD_ATTACHMENTS_FAILURE,
} from './constants';

export const initialState = {
  attachment: { file: {}, isDrawerOpen: false },
  claimNumbersRead: [],
  claims: [],
  confirmation: {
    postNewMessage: '',
    postReply: '',
  },
  error: false,
  errors: {
    bannerError: false,
    serviceError: {
      fetchMessageDetails: false,
      fetchMessages: false,
      postMessage: false,
      postReply: false,
    },
  },
  formErrors: {
    attachments: '',
    message: {
      body: '',
      subject: '',
    },
    reply: { body: '' },
    uploadDocument: { fileInput: '' },
  },
  forms: {
    attachments: [],
    message: {
      body: '',
      claimNumber: '',
      subject: '',
    },
    reply: { body: '' },
    uploadDocument: {
      fileInput: {
        documentCategory: ATTACHMENT_DOCUMENT_CATEGORY,
        fileData: '',
        fileName: '',
        fileSize: 0,
        fileType: '',
      },
    },
  },
  loading: true,
  messageDetails: {},
  messages: [],
  requestStatus: {
    chooseDocument: 'idle',
    fetchMessageDetails: 'idle',
    fetchMessages: 'idle',
    postMessage: 'idle',
    postReply: 'idle',
    processDocument: 'idle',
  },
  selectedClaimNumber: '',
  selectedMessageId: '',
  selectedTab: 'messages',
  step: 1,
};

const lossDraftReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_FORM_FIELD_VALUE: {
      const { field, form, value } = payload;
      draft.forms[form][field] = value;
      break;
    }
    case CHANGE_SELECTED_CLAIM_NUMBER: {
      const { claimNumber } = payload;
      draft.selectedClaimNumber = claimNumber;
      break;
    }
    case CHANGE_SELECTED_MESSAGE_ID: {
      const { messageId } = payload;
      draft.selectedMessageId = messageId;
      break;
    }
    case CHANGE_SELECTED_TAB: {
      const { selectedTab } = payload;
      draft.selectedTab = selectedTab;
      break;
    }
    case CHANGE_STEP: {
      const { step } = payload;
      draft.step = step;
      break;
    }
    case CHOOSE_DOCUMENT: {
      draft.requestStatus.chooseDocument = 'idle';
      break;
    }
    case CHOOSE_DOCUMENT_CANCELLATION: {
      draft.requestStatus.chooseDocument = 'idle';
      break;
    }
    case CHOOSE_DOCUMENT_FAILURE: {
      const { bannerError } = payload;
      draft.errors.bannerError = bannerError;
      draft.forms.uploadDocument.fileInput = initialState.forms.uploadDocument.fileInput;
      draft.requestStatus.chooseDocument = 'failed';
      break;
    }
    case CHOOSE_DOCUMENT_SUCCESS: {
      draft.errors.bannerError = initialState.errors.bannerError;
      draft.requestStatus.chooseDocument = 'succeeded';
      break;
    }
    case DOWNLOAD_ATTACHMENT: {
      draft.errors.bannerError = false;
      break;
    }
    case DOWNLOAD_ATTACHMENT_FAILURE: {
      const { error } = payload;
      draft.errors.bannerError = error;
      break;
    }
    case FETCH_ATTACHMENT_CANCELLED: {
      draft.requestStatus.attachment = 'idle';
      break;
    }
    case FETCH_ATTACHMENT_FAILURE: {
      const { error } = payload;
      draft.errors.bannerError = error;
      draft.requestStatus.attachment = 'failed';
      break;
    }
    case FETCH_ATTACHMENT_SUCCESS: {
      draft.requestStatus.attachment = 'succeeded';
      break;
    }
    case FETCH_LOSSDRAFT: {
      draft.error = false;
      draft.loading = true;
      break;
    }
    case FETCH_LOSSDRAFT_FAILURE: {
      const { error } = payload;
      draft.error = error;
      draft.loading = false;
      break;
    }
    case FETCH_LOSSDRAFT_SUCCESS: {
      const { claims } = payload;
      draft.claims = claims;
      draft.loading = false;
      break;
    }
    case FETCH_MESSAGE_DETAILS: {
      draft.errors.serviceError.fetchMessageDetails =
        initialState.errors.serviceError.fetchMessageDetails;
      draft.requestStatus.fetchMessageDetails = 'loading';
      break;
    }
    case FETCH_MESSAGE_DETAILS_FAILURE: {
      const { error } = payload;
      draft.errors.serviceError.fetchMessageDetails = error;
      draft.requestStatus.fetchMessageDetails = 'failed';
      break;
    }
    case FETCH_MESSAGE_DETAILS_SUCCESS: {
      const { messageDetails: { messageId, ...restProps } } = payload;
      draft.messageDetails[messageId] = restProps;
      draft.requestStatus.fetchMessageDetails = 'succeeded';
      draft.messages = draft.messages.map((message) => message.messageId === messageId
        ? { ...message, unreadReplyCount: 0 }
        : message);
      break;
    }
    case FETCH_MESSAGES: {
      draft.errors.serviceError.fetchMessages = initialState.errors.serviceError.fetchMessages;
      draft.requestStatus.fetchMessages = 'loading';
      break;
    }
    case FETCH_MESSAGES_FAILURE: {
      const { error } = payload;
      draft.errors.serviceError.fetchMessages = error;
      draft.requestStatus.fetchMessages = 'failed';
      break;
    }
    case FETCH_MESSAGES_SUCCESS: {
      const { messages } = payload;
      draft.messages = messages;
      draft.requestStatus.fetchMessages = 'succeeded';
      break;
    }
    case POST_MESSAGE: {
      draft.requestStatus.postMessage = 'loading';
      break;
    }
    case POST_MESSAGE_FAILURE: {
      const { error, nextStep } = payload;
      draft.errors.serviceError.postMessage = error;
      draft.requestStatus.postMessage = 'failed';
      if (nextStep) {
        draft.step = nextStep;
      }
      break;
    }
    case POST_MESSAGE_SUCCESS: {
      const { messageId, nextStep } = payload;
      draft.requestStatus.postMessage = 'succeeded';
      draft.confirmation.postNewMessage = messageId;
      if (nextStep) {
        draft.step = nextStep;
      }
      break;
    }
    case POST_REPLY: {
      draft.requestStatus.postReply = 'loading';
      break;
    }
    case POST_REPLY_FAILURE: {
      const { error, nextStep } = payload;
      draft.errors.serviceError.postReply = error;
      draft.requestStatus.postReply = 'failed';
      draft.step = nextStep;
      break;
    }
    case POST_REPLY_SUCCESS: {
      const { nextStep, reply: { id } } = payload;
      draft.requestStatus.postReply = 'succeeded';
      draft.confirmation.postReply = id;
      draft.step = nextStep;
      break;
    }
    case PROCESS_DOCUMENT: {
      const { file: { name } } = payload;
      draft.requestStatus.processDocument = 'loading';
      draft.errors.bannerError = initialState.errors.bannerError;
      draft.formErrors.uploadDocument = initialState.formErrors.uploadDocument;
      draft.forms.uploadDocument.fileInput = {
        ...initialState.forms.uploadDocument.fileInput,
        fileName: name,
      };
      break;
    }
    case PROCESS_DOCUMENT_FAILURE: {
      const { file, validationError } = payload;
      draft.requestStatus.processDocument = 'failed';
      if (file && validationError) {
        const {
          data: fileData,
          name: fileName,
          size: fileSize,
          type: fileType,
        } = file;
        draft.formErrors.uploadDocument.fileInput = validationError;
        draft.forms.uploadDocument.fileInput.fileData = fileData;
        draft.forms.uploadDocument.fileInput.fileName = fileName;
        draft.forms.uploadDocument.fileInput.fileSize = fileSize;
        // fileType not avaiable on mobile
        if (fileType) {
          draft.forms.uploadDocument.fileInput.fileType = fileType;
        }
        draft.forms.attachments.push({
          bannerError: validationError,
          documentCategory: ATTACHMENT_DOCUMENT_CATEGORY,
          fileData,
          fileName,
          fileSize,
          fileType,
        });
      }
      break;
    }
    case PROCESS_DOCUMENT_SUCCESS: {
      const {
        file: {
          data: fileData,
          name: fileName,
          size: fileSize,
          type: fileType,
        },
        validationError,
      } = payload;
      draft.requestStatus.processDocument = 'succeeded';
      draft.forms.uploadDocument.fileInput.fileData = fileData;
      draft.forms.uploadDocument.fileInput.fileName = fileName;
      draft.forms.uploadDocument.fileInput.fileSize = fileSize;
      // Type not avaiable on mobile
      if (fileType) {
        draft.forms.uploadDocument.fileInput.fileType = fileType;
      }
      draft.forms.attachments.push({
        bannerError: validationError,
        documentCategory: ATTACHMENT_DOCUMENT_CATEGORY,
        fileData,
        fileName,
        fileSize,
        fileType,
      });
      break;
    }
    case REMOVE_ATTACHMENT: {
      const { file, index } = payload;
      draft.forms.attachments = draft.forms.attachments.map(
        (attachment, attachmentIndex) => {
          if (attachmentIndex === index && attachment.fileName === file) {
            attachment.removed = true;
          }
          return attachment;
        },
      );
      // Reset the attachment banner error if the number of attachments is <=5
      if (draft.forms.attachments.filter(({ removed }) => !removed).length < 6) {
        draft.formErrors.attachments = initialState.formErrors.attachments;
      }
      break;
    }
    case RESET_BANNER_ERROR: {
      draft.errors.bannerError = false;
      break;
    }
    case RESET_FORM_STATE: {
      const { form } = payload;
      draft.forms[form] = initialState.forms[form];
      draft.formErrors[form] = initialState.formErrors[form];
      draft.formErrors.attachments = initialState.formErrors.attachments;
      draft.forms.attachments = initialState.forms.attachments;
      break;
    }
    case RESET_LOSS_DRAFT_STATE: {
      const { stateToReset } = payload;
      draft[stateToReset] = initialState[stateToReset];
      break;
    }
    case RESET_REQUEST_STATUS: {
      const { requestStatus } = payload;
      draft.requestStatus[requestStatus] = initialState.requestStatus[requestStatus];
      break;
    }
    case RESET_SERVICE_ERROR: {
      const { serviceError } = payload;
      draft.errors.serviceError[serviceError] = initialState.errors.serviceError[serviceError];
      break;
    }
    case RESET_STEP: {
      draft.step = initialState.step;
      break;
    }
    case RESET_USER_STATE: {
      return initialState;
    }
    case SET_ATTACHMENT_FILE: {
      const { fileName, uri } = payload || {};
      if (fileName && uri) {
        draft.attachment.file = { fileName, uri };
      } else {
        draft.attachment.file = {};
      }
      break;
    }
    case SET_BANNER_ERROR: {
      draft.errors.bannerError = payload;
      break;
    }
    case TOGGLE_ATTACHMENT_DRAWER: {
      draft.attachment.isDrawerOpen = payload;
      break;
    }
    case UPDATE_ATTACHMENTS: {
      const { isSubmit } = payload;
      if (!isSubmit) {
        /**
         * On cancel action, delete removed flags and filter attachments
         * that were previously flaged as submitted.
         */
        draft.forms.attachments = draft.forms.attachments.map(
          (attachment) => {
            if (attachment.removed) {
              delete attachment.removed;
            }
            return attachment;
          },
        );
        draft.forms.attachments = draft.forms.attachments.filter(
          ({ submitted }) => submitted,
        );
      } else {
        /**
         * On submit action, filter attachments flagged as removed and
         * flag remaining attachments as submitted.
         */
        draft.forms.attachments = draft.forms.attachments.filter(
          ({ removed }) => !removed,
        );
        draft.forms.attachments = draft.forms.attachments.map(
          (attachment) => ({ ...attachment, submitted: true }),
        );
      }
      break;
    }
    case UPDATE_CLAIM_NUMBERS_READ: {
      const { claimNumber } = payload;
      if (!draft.claimNumbersRead.includes(claimNumber)) {
        draft.claimNumbersRead.push(claimNumber);
      }
      break;
    }
    case UPLOAD_ATTACHMENTS_FAILURE: {
      const { attachmentErrors, isMobile, isReply } = payload;
      attachmentErrors.map(({ attachmentError, formUploadError, index }) => {
        if (attachmentError) {
          draft.forms.attachments[index].bannerError = attachmentError;
        } else {
          draft.formErrors.attachments = formUploadError;
        }
      });
      if (isReply) {
        draft.requestStatus.postReply = 'idle';
        draft.step = isMobile ? 3 : draft.step;
      } else {
        draft.requestStatus.postMessage = 'idle';
        draft.step = isMobile ? 4 : draft.step;
      }
      break;
    }
  }
}, initialState);

export default lossDraftReducer;
